import ar from './ar.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import id from './id.json';
import ja from './ja.json';
import ko from './ko.json';
import pt from './pt.json';
import ru from './ru.json';
import tr from './tr.json';
import tw from './tw.json';
import vi from './vi.json';
import zh from './zh.json';

export default {
  ar,
  de,
  en,
  es,
  fr,
  id,
  ja,
  ko,
  pt,
  ru,
  tr,
  tw,
  vi,
  zh
};
